(function (app) {

    app.provider('newBusinessReportsApi', [function () {
        this.$get = [
            'portalApiGateway', function (portalApiGateway) {
                var service = {};

                //GETS
                service.getPolicyDetailsByGuid = function (policyGuid) {
                    return portalApiGateway.getArray('/PolicyReport/' + policyGuid);
                };
                service.getPolicyFundingByGuid = function (policyGuid) {
                    return portalApiGateway.getArray('/PolicyReport/' + policyGuid + '/Funding');
                };
                service.getPolicySuitabilityStatusByGuid = function (policyGuid) {
                    return portalApiGateway.getArray('/PolicyReport/' + policyGuid + '/SuitabilityStatus');
                };
                service.getAgentUploadsByGuid = function (policyGuid) {
                    return portalApiGateway.getArray('/PolicyReport/' + policyGuid + '/AgentUploads');
                };
                //service.getCaseStatusByGuid = function (policyGuid) {
                //    return portalApiGateway.getArray('/PolicyReport/' + policyGuid + '/CaseStatus');
                //};
                service.getPolicyCaseStatusLatestByGuid = function (policyGuid) {
                    return portalApiGateway.getArray('/PolicyReport/' + policyGuid + '/CaseStatus/Latest');
                };
                service.getPolicyCaseStatusHistoryByGuid = function (policyGuid) {
                    return portalApiGateway.getArray('/PolicyReport/' + policyGuid + '/CaseStatus/History');
                };
                service.getVariablePolicyCaseStatusLatestByGuid = function (policyGuid) {
                    return portalApiGateway.getArray('/PolicyReport/Variable/' + policyGuid + '/CaseStatus/Latest');
                };
                service.getVariablePolicyCaseStatusHistoryByGuid = function (policyGuid) {
                    return portalApiGateway.getArray('/PolicyReport/Variable/' + policyGuid + '/CaseStatus/History');
                };

                /*PolicyReport/{policyGuid}/CaseStatus/Latest
PolicyReport/{policyGuid}/CaseStatus/History
PolicyReport/Variable/{policyGuid}/CaseStatus/Latest
PolicyReport/Variable/{policyGuid}/CaseStatus/History*/

                //POSTS
                //Using post since gets don't normally take in body model
                service.getPendingPolicies = function (agentGuidListModel) {
                    return portalApiGateway.post('/PolicyReport/Pending', agentGuidListModel);
                };
                //Using post since gets don't normally take in body model
                service.getInforcePolicies = function (agentGuidListModel) {
                    return portalApiGateway.post('/PolicyReport/Inforce', agentGuidListModel);
                };
                service.exportPendingPolicies = function (agentGuidListModel) {
                    return portalApiGateway.getFilePost('/PolicyReport/Export/Policies/Pending', agentGuidListModel);
                };
                service.exportInforcePolicies = function (agentGuidListModel) {
                    return portalApiGateway.getFilePost('/PolicyReport/Export/Policies/Inforce', agentGuidListModel);
                };
                service.postPolicyFiles = function (policyGuid, formData) {
                    return portalApiGateway.postFile("/FileUpload/" + policyGuid, formData);
                };
                return service;
            }
        ];
    }]);

})(window.app);